import * as constants from './constants';

export function authenticate(payload) {
  return {
    type: constants.AUTHENTICATE,
    payload
  };
}

export function authenticateDone(payload) {
  return {
    type: constants.AUTHENTICATE_DONE,
    payload
  };
}

export function authenticateFail(payload) {
  return {
    type: constants.AUTHENTICATE_FAIL,
    payload
  };
}

export function userLoaded(payload) {
  return {
    type: constants.USER_LOADED,
    payload
  };
}

export function loadCachedUserAttempted(payload) {
  return {
    type: constants.LOAD_CACHED_USER_ATTEMPTED,
    payload
  };
}

export function logout(payload) {
  return {
    type: constants.LOGOUT,
    payload
  };
}
